



























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { Base } from '@/components/common/base';
import { dealService, departmentService, storeService } from '@/shared';
import { PaginationModel } from '@/models/pagedlistmodel';
import { ValidationRules } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class DepartmentSavePage extends Base {
  public stores: any[];
  public loading: boolean = false;
  public pagination = new PaginationModel('name');
  public blockId = '';
  public dealRecapBlocks: any = {
    id: '',
    storeId: 0,
    blockName: '',
    sequenceNumber: 0,
    totalTitle: '',
    grossTotalType: '',
    lineItem: [],
  };

  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public storeId: any = 0;
  public paymentTypes: any[];
  public disableSubmitButton: boolean = false;
  public grossTotalType = [
    {
      key: 1,
      value: 'TOTAL FRONT-END GROSS',
    },
    {
      key: 2,
      value: 'TOTAL BACK-END GROSS',
    },
  ];

  public unlinkedDepartments: any;

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.$router.push({
        name: 'admin.dealaccounts.dealrecap',
        params: { storeId: this.storeId },
      });
    }
    if (methodName === 'submit') {
      if (!this.form.$valid) {
        this.showAlert(false, 'Form is Invalid!');
        this.resetMethodName(methodName);
        return;
      }
      this.submitBlock();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    if (this.storeId) {
      buttons.push({
        id: '0',
        type: 'button',
        title: this.$parent.$t('departments.btnBack'),
        disabled: false,
        visible: true,
        class: 'btn',
        label: this.$parent.$t('departments.btnBack'),
        click: 'backToList',
        icon: 'fas fa-arrow-left',
      });
    }
    this.$emit('updateToolBar', buttons);
  }
  public async mounted(): Promise<void> {
    this.setFields();
    this.storeId = String(this.$route.params.storeId);
    this.dealRecapBlocks.storeId = this.storeId;
    this.blockId = this.$route.params.id;
    if (this.$route.params.id) {
      this.getDealBlocks(this.storeId);
    }

    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
  }

  public async getDealBlocks(storeId: number): Promise<void> {
    try {
      this.loading = true;
      this.formlyShowSkeleton(this.formFields);
      const blocksResult = await dealService.getDealBlocks(
        storeId,
        this.pagination
      );
      if (blocksResult.results) {
        var res = blocksResult.results.filter((x) => x.id == this.blockId)[0];
        this.dealRecapBlocks.id = res.id;
        this.dealRecapBlocks.blockName = res.blockName;
        this.dealRecapBlocks.sequenceNumber = res.sequenceNumber;
        this.dealRecapBlocks.totalTitle = res.totalTitle;
        this.dealRecapBlocks.grossTotalType = res.grossTotalType;
        this.dealRecapBlocks.lineItem = res.lineItem;
      }
    } finally {
      this.loading = false;
      this.formlyHideSkeleton(this.formFields);
    }
  }

  public validateBlock(): Vue & { validate: () => boolean } {
    return this.$refs.dealRecapBlockForm as Vue & { validate: () => boolean };
  }

  public async submitBlock(): Promise<void> {
    if(this.validateBlock().validate()){
      try {
        this.disableSubmitButton = true;
        this.$emit('update:progress', this.disableSubmitButton);
        if (this.dealRecapBlocks.sequenceNumber == 0) {
          this.showAlert(false, 'Sequence no can not be 0');
          return;
        }

        if (this.$route.params.id) {
          try {
            await dealService.saveDealsBlockAsync(
              this.dealRecapBlocks,
              Number(this.storeId)
            );
            this.showAlert(true, 'Deal Block Updated Successfully');
            this.$router.push({
              name: 'admin.dealaccounts.dealrecap',
              params: { storeId: this.storeId.toString() },
            });
          } catch (e) {
            console.log(e);
          }
        } else {
          try {
            await dealService.saveDealsBlockAsync(
              this.dealRecapBlocks,
              Number(this.storeId)
            );
            this.showAlert(true, 'Deal Block Added Successfully');
            this.$router.push({
              name: 'admin.dealaccounts.dealrecap',
              params: { storeId: this.storeId.toString() },
            });
          } catch (e) {
            console.log(e);
          }
        }
      } finally {
        this.disableSubmitButton = false;
        this.$emit('update:progress', this.disableSubmitButton);
      }
    }
  }
  public setFields(): void {
    this.formFields = [
      {
        key: 'blockName',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 30,
          label: 'Block Name',
          required: true,
          disabled: false,
          loading: false,
          rules:[
            v =>  this.required('Block Name',v)
          ]
        },
      },
      {
        key: 'grossTotalType',
        type: 'v-alynk-select',
        required: true,
        templateOptions: {
          counter: 500,
          label: 'Select Options',
          disabled: false,
          items: this.grossTotalType,
          text: 'value',
          value: 'value',
          altag: 'Select Gross Total Type',
          loading: false,
          rules:[
            v =>  this.required('Select Options',v)
          ]
        },
      },
      {
        key: 'sequenceNumber',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 7,
          label: 'Block Sequence Number',
          type: 'number',
          required: true,
          disabled: false,
          loading: false,
          rules:[
            v =>  this.required('Block Sequence Number',v)
          ]
        },
      },
      {
        key: 'totalTitle',
        type: 'v-alynk-text-field',
        required: true,
        templateOptions: {
          counter: 30,
          label: 'Title For Block Sum',
          required: true,
          disabled: false,
          loading: false,
          rules:[
            v =>  this.required('Title For Block Sum',v)
          ]
        },
      },
    ];
  }
  public async getStores(): Promise<void> {
    const stores = await storeService.getStoresList();
    this.stores = stores.results;
    this.storeId = String(this.$route.params.storeId);
    this.formFields[0].templateOptions.items = this.stores;
  }
}
